import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "check-list",
  "use": "check-list-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"check-list\"><path d=\"M5.71 9.17l-2.3-2.29L2 8.29 5.71 12l6.7-6.71L11 3.88 5.71 9.17zM5.71 17.17l-2.3-2.29L2 16.29 5.71 20l6.7-6.71L11 11.88l-5.29 5.29zM5.71 25.17l-2.3-2.29L2 24.29 5.71 28l6.7-6.71L11 19.88l-5.29 5.29zM14 7.88h16v2H14zM14 15.88h16v2H14zM14 24h16v2H14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/check-list.svg
// module id = CLiG
// module chunks = 38 43